



































































import ForgetPassword from './ForgetPassword'
import Vue, { VNode } from 'vue'
import { SigninGuard } from '@rhitics/core/libs/SigninGuard'
import Layout from '@rhitics/vue/components/Layout'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'

export default Layout.extend({
  name: 'Login',

  components: {
    AppLayout,
    ForgetPassword 
  },

  data() {
    return {
      error: '',
      showPassword: false,
      form: {
        email: '',
        password: '',
        loading: false
      }
    }
  },

  methods: {
    async submit(event: Event) {
      event.preventDefault()
      if (this.form.loading) return
      try {
        this.form.loading = true
        const { email, password } = this.form

        await this.$auth.login(email, password)

        if (this.isLogin) SigninGuard.redirectToDestination()

      } catch (error) {
        let message = 'Oops! looks something went wrong, please contact IT team.'
        if (error.response) {
          const response = error.response
          if (response.status === 401) {
            message = 'Email not exists or password incorrect, please check your input.'
          }
        } else if (error.message) {
          message = error.message
        }
        this.error = message
        window.setTimeout(() => (this.error = ''), 5000)
      } finally {
        this.form.loading = false
      }

      event.preventDefault()
    }
  }
})
